<div class="clear"></div>
<section class="banner">
    <div class="container py-2">
        <h1>Top Management</h1>
    </div>
</section>

<div class="class py-3"></div>

<section class="container py-2">
    <div class="row justify-content-center">
        <div class="col-lg-10 text-center mb-4">
            <p class="lead text-primary">
                The Public Procurement Regulatory Authority is an autonomous body responsible for establishing
                regulations and procedures
                for public procurements by Federal Government-owned organizations, focusing on improving governance,
                transparency,
                accountability, and quality in the public procurement of goods, works, and services.
            </p>
        </div>

        <div class="col-lg-10">
            <div class="vertical-list">
                <div class="vertical-item mb-4">
                    <div class="d-flex align-items-center">
                        <div class="col-4 text-center">
                            <img src="../assets/images/pmtopmanagement.jpg" alt="Prime Minister"
                                class="carousel-img img-fluid rounded-circle shadow">
                        </div>
                        <div class="col-8 text-left">
                            <h4 class="text-primary font-weight-bold">Mian Muhammad Shehbaz Sharif</h4>
                            <h6 class="text-black">Prime Minister of Pakistan</h6>
                            <!-- <p class="message">"Prime Minister message here set."</p> -->
                        </div>
                    </div>
                </div>
                <div class="vertical-item mb-4">
                    <div class="d-flex align-items-center">
                        <div class="col-4 text-center">
                            <img src="../assets/images/secy.jpg" alt="Cabinet Secretary"
                                class="carousel-img img-fluid rounded-circle shadow">
                        </div>
                        <div class="col-8 text-left">
                            <h4 class="text-primary font-weight-bold">Kamran Ali Afzal</h4>
                            <h6 class="text-black">Cabinet Secretary</h6>
                            <!-- <p class="message">"We are here to support the government’s initiatives."</p> -->
                        </div>
                    </div>
                </div>
                <div class="vertical-item mb-4">
                    <div class="d-flex align-items-center">
                        <div class="col-4 text-center">
                            <img src="../assets/images/finsecy.jpeg" alt="Finance Secretary"
                                class="carousel-img img-fluid rounded-circle shadow">
                        </div>
                        <div class="col-8 text-left">
                            <h4 class="text-primary font-weight-bold">Imdad Ullah Bosal</h4>
                            <h6 class="text-black">Finance Secretary</h6>
                            <!-- <p class="message">"We are committed to financial stability."</p> -->
                        </div>
                    </div>
                </div>
                <div class="vertical-item mb-4">
                    <div class="d-flex align-items-center">
                        <div class="col-4 text-center">
                            <img src="../assets/images/MD Hasnaat.jpg" alt="Managing Director"
                                class="carousel-img img-fluid rounded-circle shadow">
                        </div>
                        <div class="col-8 text-left">
                            <h4 class="text-primary font-weight-bold">Hasnat Ahmed Qureshi</h4>
                            <h6 class="text-black">Managing Director PPRA</h6>
                            <!-- <p class="message">"Our mission at the Federal Public Procurement Regulatory Authority is to ensure that public procurement processes are conducted with the highest standards of transparency, efficiency, and accountability. Public procurement is a cornerstone of good governance, and our role is to facilitate a procurement environment that delivers value for money, supports sustainable development, and fosters trust in public institutions. We are committed to upholding the principles of fairness and integrity in all our activities. Through the implementation of robust regulations and the promotion of best practices, we strive to make the procurement process more accessible, competitive, and effective for all stakeholders. We are embracing digital transformation to streamline procurement procedures. Our e-procurement platform is designed to make the process more efficient, reducing the time and costs associated with procurement while increasing accessibility for suppliers. We recognize the importance of sustainable procurement practices that consider the long-term impact on the environment and society. Our policies are aligned with global best practices to promote responsible procurement that contributes to sustainable development. We encourage you to explore our website, where you will find a wealth of resources, including guidelines, regulations, and updates on our latest initiatives. Whether you are a supplier, a government entity, or a member of the public, we are here to support you in navigating the procurement process."</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>